import { forwardRef } from 'react';

import { cx } from '../../lib/cx';
import { useControlId } from '../../lib/use-id';
import { Field, fieldIds } from '../field';
import type { InputProps } from './types';

/**
 * Text input with its label, help and error wired for assistive technology.
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, help, error, id: providedId, className, required, ...props },
  ref,
) {
  const id = useControlId(providedId);
  const ids = fieldIds(id);
  return (
    <Field
      id={id}
      label={label}
      {...(help ? { help } : {})}
      {...(error ? { error } : {})}
      {...(required ? { required } : {})}
    >
      <input
        ref={ref}
        id={id}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? ids.error : help ? ids.help : undefined}
        required={required}
        className={cx(
          'control-touch rounded-control border bg-white px-3 py-2 text-sm text-gray-900 outline-none transition-colors',
          'placeholder:text-gray-400 focus:border-brand-500 focus:ring-2 focus:ring-brand-100',
          'disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500',
          error
            ? 'border-danger-600 focus:border-danger-600 focus:ring-danger-100'
            : 'border-gray-300',
          className,
        )}
        {...props}
      />
    </Field>
  );
});
